import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "alert alert-success mb-4"
}
const _hoisted_5 = {
  key: 3,
  class: "form widget s20 py-8 pb-10"
}
const _hoisted_6 = { class: "container-full-1" }
const _hoisted_7 = { class: "form-field-floating reactive my-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating reactive my-4" }
const _hoisted_10 = {
  key: 1,
  class: "text-red"
}
const _hoisted_11 = { class: "form-field-floating reactive my-4" }
const _hoisted_12 = {
  key: 2,
  class: "text-red"
}
const _hoisted_13 = { class: "form-field-floating reactive my-4" }
const _hoisted_14 = {
  key: 3,
  class: "text-red"
}
const _hoisted_15 = { class: "form-field-floating reactive my-4" }
const _hoisted_16 = { class: "form-field-floating reactive my-4" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 4,
  class: "text-red"
}
const _hoisted_19 = { class: "custom-upload-size margin-auto flex my-8" }
const _hoisted_20 = { class: "custom-upload-st2" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  src: "/public/icons/icon-profil.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_23 = { class: "s10" }
const _hoisted_24 = { class: "custom-upload-text-sm" }
const _hoisted_25 = { class: "flex gap-2" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }

import { reactive, ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import { showAlert } from '@/utils/swal'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembreEdit',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const pageLoading = ref(false)
const loading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

const startupInfos = reactive({
  collectivites: [] as any[]
})

const formData = reactive({
  id: null as number | null,
  nom: '',
  prenom: '',
  email: '',
  telephone: '',
  fonction: '',
  collectivite_id: null as number | null,
  photo: null as { file: File; name: string } | null,
  photo_preview: null as string | null
})

const errors = reactive({
  nom: '',
  prenom: '',
  email: '',
  telephone: '',
  collectivite_id: ''
})

const photoPreviewStyle = computed(() => {
  if (formData.photo_preview && typeof formData.photo_preview === 'string') {
    return { background: `url('${formData.photo_preview}')`, backgroundSize: 'cover' }
  }
  return { background: "url('/public/icons/empty.png')", backgroundSize: 'cover' }
})

onMounted(async () => {
  const memberId = route.params.id
  if (memberId) {
    await loadStartupInfos()
    await loadMember(Number(memberId))
  } else {
    router.push({ name: 'collectivites-membres' })
  }
})

async function loadStartupInfos() {
  try {
    const data = await membersService.getStartupInfos()
    startupInfos.collectivites = data.collectivites || []
  } catch (error: any) {
    console.error('Erreur lors du chargement des données de démarrage:', error)
  }
}

async function loadMember(id: number) {
  try {
    pageLoading.value = true
    errorMessage.value = ''
    // Utiliser la nouvelle route frontoffice
    const data = await membersService.getMemberFormDatas(id)
    
    formData.id = data.user.id
    formData.nom = data.user.nom || ''
    formData.prenom = data.user.prenom || ''
    formData.email = data.user.email || ''
    formData.telephone = data.user.telephone || ''
    formData.fonction = data.user.fonction || ''
    formData.collectivite_id = data.collectivite_id || null
    
    if (data.user.photo) {
      formData.photo_preview = data.user.photo_url
    } else {
      formData.photo_preview = '/public/assets/users/300w/user2.jpg'
    }
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors du chargement du membre'
    setTimeout(() => {
      router.push({ name: 'collectivites-membres' })
    }, 2000)
  } finally {
    pageLoading.value = false
  }
}

function handlePhotoUpload(event: Event) {
  const input = event.target as HTMLInputElement
  if (!input.files || input.files.length === 0) {
    return
  }

  const file = input.files[0]
  const reader = new FileReader()
  reader.onload = e => {
    formData.photo = {
      file,
      name: file.name
    }
    formData.photo_preview = e.target?.result as string ?? null
  }
  reader.readAsDataURL(file)
}

function validateEmail(emailValue: string): boolean {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(emailValue)
}

function validatePhone(phoneValue: string): boolean {
  const regex = /^\+?[0-9]{8,15}$/
  return regex.test(phoneValue)
}

function validate(): boolean {
  let isValid = true
  Object.keys(errors).forEach(key => {
    errors[key as keyof typeof errors] = ''
  })

  if (!formData.nom) {
    errors.nom = 'Le nom est requis'
    isValid = false
  }

  if (!formData.prenom) {
    errors.prenom = 'Le prénom est requis'
    isValid = false
  }

  if (!formData.email) {
    errors.email = "L'email est requis"
    isValid = false
  } else if (!validateEmail(formData.email)) {
    errors.email = "L'adresse email est invalide"
    isValid = false
  }

  if (!formData.telephone) {
    errors.telephone = 'Le téléphone est requis'
    isValid = false
  } else if (!validatePhone(formData.telephone)) {
    errors.telephone = 'Le téléphone est invalide'
    isValid = false
  }

  if (!formData.collectivite_id) {
    errors.collectivite_id = 'La collectivité est requise'
    isValid = false
  }

  return isValid
}

async function onSubmit() {
  if (!validate()) {
    return
  }

  loading.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const formToUpload = new FormData()
    if (formData.id != null) {
      formToUpload.append('id', `${formData.id}`)
    }
    formToUpload.append('nom', formData.nom)
    formToUpload.append('prenom', formData.prenom)
    formToUpload.append('email', formData.email)
    formToUpload.append('telephone', formData.telephone)
    formToUpload.append('fonction', formData.fonction || '')
    formToUpload.append('collectivite_id', `${formData.collectivite_id}`)

    if (formData.photo?.file) {
      formToUpload.append('photo', formData.photo.file, formData.photo.name)
    }

    // Utiliser la nouvelle route frontoffice pour la mise à jour
    await membersService.updateMemberFrontoffice(formData.id!, formToUpload)
    successMessage.value = 'Membre modifié avec succès.'
    await showAlert.success('Membre modifié avec succès.', 'Modification réussie')
    
    // Rediriger vers la liste après un court délai
    setTimeout(() => {
      router.push({ name: 'collectivites-membres' })
    }, 1500)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la modification du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de modification')
  } finally {
    loading.value = false
  }
}

function goBack() {
  router.push({ name: 'collectivites-membres' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membres - Édition du membre", -1))
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    (pageLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (!pageLoading.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
              _createTextVNode("Informations personnelles "),
              _createElementVNode("span", { class: "text-sm text-grey-500" })
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
                name: "nom",
                id: "nom",
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.nom]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", { for: "nom" }, [
                _createTextVNode("Nom "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (errors.nom)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors.nom), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.prenom) = $event)),
                name: "prenom",
                id: "prenom",
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.prenom]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "prenom" }, [
                _createTextVNode("Prénom "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (errors.prenom)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors.prenom), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                name: "email",
                id: "email",
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.email]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "email" }, [
                _createTextVNode("Email "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (errors.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errors.email), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.telephone) = $event)),
                name: "telephone",
                id: "telephone",
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.telephone]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "telephone" }, [
                _createTextVNode("Téléphone "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (errors.telephone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(errors.telephone), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.fonction) = $event)),
                name: "fonction",
                id: "fonction",
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.fonction]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "fonction" }, "Fonction", -1))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.collectivite_id) = $event)),
                name: "collectivite_id",
                id: "collectivite_id"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Sélectionnez une collectivité", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.collectivites, (collectivite) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: collectivite.id,
                    key: collectivite.id
                  }, _toDisplayString(collectivite.nom), 9, _hoisted_17))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.collectivite_id]
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("label", { for: "collectivite_id" }, [
                _createTextVNode("Collectivité "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (errors.collectivite_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.collectivite_id), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", {
                for: 'photo-upload',
                class: _normalizeClass(["custom-upload my-5", { active: formData.photo }])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("input", {
                    id: 'photo-upload',
                    class: "display-none",
                    type: "file",
                    onChange: handlePhotoUpload,
                    accept: ".jpg,.jpeg,.png,.gif,.webp,.svg"
                  }, null, 32),
                  _createElementVNode("div", {
                    class: "s5 custom-upload-img",
                    style: _normalizeStyle(photoPreviewStyle.value)
                  }, [
                    (formData.photo_preview && typeof formData.photo_preview === 'string')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: formData.photo_preview,
                          width: "100%",
                          style: {"object-fit":"cover"}
                        }, null, 8, _hoisted_21))
                      : (_openBlock(), _createElementBlock("img", _hoisted_22))
                  ], 4),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Photo de profil", -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(formData.photo?.name || "Charger l'image"), 1)
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "s5 right" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-upload.svg",
                      class: "custom-upload-icon"
                    })
                  ], -1))
                ])
              ], 2)
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-xs text-grey-500 mb-5" }, [
              _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
              _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
            ], -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn lg w-100",
                disabled: loading.value,
                onClick: onSubmit
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("img", {
                  src: "/public/icons/icon-enregistrer.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Enregistrer"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_28, "Enregistrement..."))
              ], 8, _hoisted_26)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})